<template>
  <!-- App.vue -->
  <v-app>
    <v-app-bar app dense dark color="light-blue darken-1">
      <v-toolbar-title
        class="text-h4 font-weight-bold font-italic"
        color="brown lighten-4"
      >
        PortDistance
      </v-toolbar-title>
      <v-card flat color="light-blue darken-1" class="ml-12">
        <!--
        <v-btn text large color="white">
          <v-icon small left class="mr-2">mdi-map-marker-distance</v-icon>
          {{ $t('m.distance') }}
        </v-btn>
        -->
        <v-btn
          text
          color="white"
          @click="listEstimation"
          class="text-subtitle-1 font-weight-bold"
        >
          <v-icon left class="mr-2"> mdi-chart-tree </v-icon>
          {{ $t("m.estimation") }}
        </v-btn>

        <v-btn
          text
          color="white"
          @click="showShipList"
          class="text-subtitle-1 font-weight-bold ml-2"
        >
          <v-icon left class="mr-2"> mdi-ship-wheel </v-icon>
          {{ $t("m.vessel") }}
        </v-btn>
      </v-card>
      <v-spacer />

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-card
            flat
            color="transparent"
            v-bind="attrs"
            v-on="on"
            class="d-flex align-center"
          >
            <v-avatar color="grey lighten-2" size="30">
              <template v-if="headerimg">
                <img :src="headerimg" />
              </template>
              <template v-else>
                <v-icon color="grey lighten-1" x-large> mdi-account </v-icon>
              </template>
            </v-avatar>
            <span class="ml-2">{{ operName }}</span>
            <v-icon>mdi-menu-down</v-icon>
          </v-card>
        </template>
        <v-list dense>
          <v-list-item-group v-model="settingsIndex" color="primary">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-shopping-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.purchaseInfo") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-cart-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.shopping") }}
              </v-list-item-title>
            </v-list-item>

            <v-divider />

            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.personalProfile") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-email-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.changeAccount") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-lock-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.changePasswd") }}
              </v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">
                {{ $t("m.logout") }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <!-- end setting menu -->

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="ml-4">
            {{ langArr[selectedLangIndex].title }}
            <v-icon color=""> mdi-menu-down </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="selectedLangIndex" color="primary">
            <v-list-item v-for="(item, index) in langArr" :key="index">
              <v-list-item-title v-html="item.title" class="text-body-2" />
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="mr-n3">
            {{ $t("m.aboutus") }}
            <v-icon color=""> mdi-menu-down </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="selectedAboutusIndex" color="primary">
            <v-list-item>
              <v-list-item-title class="text-body-2">
                <v-list-item-title class="text-body-2">
                  {{ $t("m.aboutPortdistance") }}
                </v-list-item-title>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="text-body-2">
                <v-list-item-title class="text-body-2">
                  {{ $t("m.aboutMarineCircle") }}
                </v-list-item-title>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="text-body-2">
                <v-list-item-title class="text-body-2">
                  {{ $t("m.contactus") }}
                </v-list-item-title>
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- 根据应用组件来调整你的内容 -->
    <v-main>
      <!-- 给应用提供合适的间距 -->
      <v-container fluid class="pa-0">
        <!-- 如果使用 vue-router -->
        <router-view />

        <v-snackbar
          v-model="successSnackbar"
          color="blue-grey"
          absolute
          top
          timeout="2000"
          rounded="pill"
        >
          {{ successSnackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="successSnackbar = false"
            >
              CLOSE
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>

    <LoginDialog :visible="loginDlgVisible" @close="closeLoginDlg" />

    <EstimationDialog :visible="estDlgVisible" @cancel="cancelListEstimation" />

    <ShipInfoListDialog
      :visible="shipListDlgVisible"
      @cancel="cancelShipList"
    />

    <OperBaseInfoEditDialog
      :visible="baseEditDlgVisible"
      @cancel="cancelBaseEdit"
      @save="updateSuccessForBaseEdit"
    />

    <AccountEditDialog
      :visible="accountEditDlgVisible"
      @cancel="cancelAccountEdit"
      @save="updateSuccessForAccountEdit"
    />

    <PasswordEditDialog
      :visible="pwdEditDlgVisible"
      @cancel="cancelPwdEdit"
      @save="updateSuccessForPwdEdit"
    />

    <AlertConfirmDlg
      :visible="alertConfirmDlgVisible"
      :title="alertTitle"
      :content="alertContent"
      @cancel="cancelAlertDlg"
      @confirm="confirmAlertDlg"
    />
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utils from "@/utils/index";
import httpClient from "@/api/httpClient";
import ECAUtil from "@/utils/ecaUtil";
import Constant from "@/constant";
import AlertConfirmDlg from "@/components/AlertConfirmDlg";

import EstimationDialog from "@/views/EstimationDialog";
import ShipInfoListDialog from "@/views/ShipInfoListDialog";
import OperBaseInfoEditDialog from "@/views/OperBaseInfoEditDialog";
import PasswordEditDialog from "@/views/PasswordEditDialog";
import AccountEditDialog from "@/views/AccountEditDialog";
import LoginDialog from "@/views/LoginDialog";

export default {
  components: {
    AlertConfirmDlg,
    LoginDialog,
    EstimationDialog,
    ShipInfoListDialog,
    PasswordEditDialog,
    AccountEditDialog,
    OperBaseInfoEditDialog,
  },
  data() {
    return {
      selectedLangIndex: this.$i18n.locale == "en-US" ? 0 : 1,
      langArr: [
        { val: "en-US", title: "English" },
        { val: "zh-CN", title: "中文" },
      ],

      loginDlgVisible: false,

      settingsIndex: null,
      selectedAboutusIndex: null,
      estDlgVisible: false,
      shipListDlgVisible: false,
      pwdEditDlgVisible: false,
      accountEditDlgVisible: false,
      baseEditDlgVisible: false,
      myDlgVisible: false,

      alertConfirmDlgVisible: false,
      alertTitle: "",
      alertContent: "",
      successSnackbar: false,
      successSnackbarText: null,
    };
  },
  created() {
    var operID = Utils.getWithExpiry("operID");
    if (operID) {
      this.queryUserInfo();
      this.$store.dispatch("getCountryArr");
      this.$store.dispatch("getDictionaryArr");
    }

    ECAUtil.dealEcaPolyArr().then((ecaLineList) => {
      this.$store.commit("setEcaLines", ecaLineList);
    });
    ECAUtil.dealEcaAreaArr().then((ecaAreaList) => {
      this.$store.commit("setEcaAreas", ecaAreaList);
    });
  },
  mounted: function () {},
  computed: {
    ...mapState({
      userOnline: (state) => state.user.userOnline,
      operName: (state) => state.user.operName,
    }),

    headerimg() {
      // headerimg
      if (
        this.$store.state.user.pictureURL &&
        this.$store.state.user.pictureURL.length > 0
      ) {
        return (
          "http://www.marinecircle.com/resourcelib/personal/" +
          this.$store.state.user.pictureURL
        );
      }
      return null;
    },
  },
  watch: {
    userOnline: function (val) {
      var operID = Utils.getWithExpiry("operID");
      if (val === true) {
        this.queryUserInfo();
        this.$store.dispatch("getCountryArr");
        this.$store.dispatch("getDictionaryArr");
      }
    },

    selectedLangIndex: function (val) {
      if (val == null) return;
      var lang = this.langArr[val].val;
      this.$i18n.locale = lang;
      Utils.setWithExpiry(
        "userLang",
        lang,
        Constant.LOCALSTORAGE_EXPIRY_PERIOD_LONG
      );
      Utils.setCookie("user-lang", lang, 30);
      // document.querySelector('html').setAttribute('lang', lang)
    },

    settingsIndex: function (val) {
      if (val == null) return;

      if (val == 0) {
        if (this.$i18n.locale == "en-US") {
          window.open("http://www.portdistance.com/jsp/login.jsp?lang=en_US");
        } else {
          window.open("http://www.portdistance.com/jsp/login.jsp?lang=zh_CN");
        }
      } else if (val == 1) {
        if (this.$i18n.locale == "en-US") {
          window.open("http://www.portdistance.com/jsp/price.jsp?lang=en_US");
        } else {
          window.open("http://www.portdistance.com/jsp/price.jsp?lang=zh_CN");
        }
      } else if (val == 2) {
        this.baseEditDlgVisible = true;
      } else if (val == 3) {
        this.accountEditDlgVisible = true;
      } else if (val == 4) {
        // 密码修改
        this.pwdEditDlgVisible = true;
      } else if (val == 5) {
        // 退出
        this.alertContent = this.$t("m.comfirmQuit");
        this.alertConfirmDlgVisible = true;
      }
    },

    selectedAboutusIndex: function (val) {
      if (val == null) return;

      if (val == 0) {
        if (this.$i18n.locale == "en-US") {
          window.open("http://www.portdistance.com/#?lang=en_US");
        } else {
          window.open("http://www.portdistance.com/#?lang=zh_CN");
        }
      } else if (val == 1) {
        if (this.$i18n.locale == "en-US") {
          window.open("https://marinecircle.com/index_en.html");
        } else {
          window.open("https://marinecircle.com/");
        }
      } else if (val == 2) {
        if (this.$i18n.locale == "en-US") {
          window.open("https://marinecircle.com/html/en/aboutus_en.html");
        } else {
          window.open("https://marinecircle.com/html/cn/aboutus.html");
        }
      }
    },
  },

  methods: {
    queryUserInfo() {
      var param = {
        OperID: Utils.getWithExpiry("operID"),
        QueryOperID: Utils.getWithExpiry("operID"),
      };
      httpClient
        .post("/OPUserRegInfoQry", param)
        .then((res) => {
          this.$store.commit("setOperInfo", res.data.message);
        })
        .catch((err) => {});
    },

    listEstimation() {
      this.estDlgVisible = true;
    },
    cancelListEstimation() {
      this.estDlgVisible = false;
    },

    showShipList() {
      this.shipListDlgVisible = true;
    },
    cancelShipList() {
      this.shipListDlgVisible = false;
    },

    cancelBaseEdit() {
      this.settingsIndex = null;
      this.baseEditDlgVisible = false;
    },
    updateSuccessForBaseEdit() {
      this.settingsIndex = null;
      this.baseEditDlgVisible = false;
      this.successSnackbarText = this.$t("m.updatedSuccess");
      this.successSnackbar = true;
    },

    cancelAccountEdit() {
      this.settingsIndex = null;
      this.accountEditDlgVisible = false;
    },
    updateSuccessForAccountEdit() {
      this.settingsIndex = null;
      this.accountEditDlgVisible = false;
      this.successSnackbarText = this.$t("m.updatedSuccess");
      this.successSnackbar = true;
    },

    cancelPwdEdit() {
      this.settingsIndex = null;
      this.pwdEditDlgVisible = false;
    },
    updateSuccessForPwdEdit() {
      this.settingsIndex = null;
      this.pwdEditDlgVisible = false;
      this.successSnackbarText = this.$t("m.updatedSuccess");
      this.successSnackbar = true;
    },

    cancelAlertDlg() {
      this.alertConfirmDlgVisible = false;
      this.settingsIndex = null;
    },
    confirmAlertDlg() {
      this.alertConfirmDlgVisible = false;
      this.settingsIndex = null;
      // 退出登录
      this.loginDlgVisible = true;
      localStorage.removeItem("operID");
      localStorage.removeItem("operName");
      localStorage.removeItem("token");
      localStorage.removeItem("accessCode");

      this.$store.commit("setOperInfo", {});
      this.$store.commit("setUserOnline", false);

      this.$store.commit("setUserLogoutClearFlag", true);
    },
    closeLoginDlg() {
      this.loginDlgVisible = false;
    },
  },
};
</script>
